export default "__VITE_ASSET__CgiHlwWL__"